/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_TimeInputs */

const en_gc_resources_guide_start_time = /** @type {(inputs: Gc_Resources_Guide_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 min read`)
};

const zh_gc_resources_guide_start_time = /** @type {(inputs: Gc_Resources_Guide_Start_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读约 4 分钟`)
};

/**
* | output |
* | --- |
* | "4 min read" |
*
* @param {Gc_Resources_Guide_Start_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_time = /** @type {((inputs?: Gc_Resources_Guide_Start_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_time(inputs)
	return zh_gc_resources_guide_start_time(inputs)
});
export { gc_resources_guide_start_time as "gc.resources.guide.start.time" }